import { Profile } from 'oidc-client';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Transfers from './Transfers';

export interface Props extends RouteComponentProps {
    userProfile: Profile;
}

export default withRouter(Transfers);
